// 遍历页面中所有的v-image-text-one-line-section组件
const imageTextOneSections = document.querySelectorAll('.v-image-text-one-line-section');

imageTextOneSections.forEach((section, sectionIndex) => {
    // 遍历当前section中的所有v-image-text-one-line-block
    const imageTextBlocks = section.querySelectorAll('.v-image-text-one-line-block');

    imageTextBlocks.forEach((block, blockIndex) => {
        // 查找当前block中的所有jds-button
        const jdsButtons = block.querySelectorAll('jds-button');
        
        jdsButtons.forEach((button, buttonIndex) => {
            if (button.dataset.gaBound === 'true') return;
            button.dataset.gaBound = 'true';

            // 为每个jds-button添加点击事件
            button.addEventListener('click', (e) => {
                // 获取按钮文案
                const buttonText = button.textContent.trim();
                
                // 获取跳转链接
                const linkElement = button.querySelector('a') || button;
                const href = linkElement.getAttribute('href') || linkElement.getAttribute('data-href') || '无链接';

                // 获取前一个 blocks-heading-content 组件中的标题文本
                let prevHeadingText = {
                pc: '',
                mb: ''
                };
                
                // 查找当前 section 的前一个兄弟元素
                let prevSection = section.previousElementSibling;
                
                // 遍历前面的兄弟元素，查找包含 blocks-heading-content 的组件
                while (prevSection) {
                const headingContentBlock = prevSection.querySelector('.blocks-heading-content');
                if (headingContentBlock) {
                    // 查找 blocks-content-heading 元素
                    const headingElement = headingContentBlock.querySelector('.blocks-content-heading');
                    if (headingElement) {
                    // 获取 PC 端文本（lg:block 显示的内容）
                    const pcElement = headingElement.querySelector('.hidden.lg\\:block');
                    if (pcElement) {
                        prevHeadingText.pc = pcElement.textContent.trim();
                    }
                    
                    // 获取 MB 端文本（lg:hidden 显示的内容）
                    const mbElement = headingElement.querySelector('.block.lg\\:hidden');
                    if (mbElement) {
                        prevHeadingText.mb = mbElement.textContent.trim();
                    }
                    
                    break; // 找到第一个匹配的就停止
                    }
                }
                prevSection = prevSection.previousElementSibling;
                }
                
                // 根据屏幕尺寸选择对应的文案
                const isDesktop = window.innerWidth > 1024;
                const selectedHeadingText = isDesktop ? prevHeadingText.pc : prevHeadingText.mb;
                
                // 新增：获取当前按钮的父节点button-wrapper的前一个兄弟节点blocks-heading-content中的另一个文本
                let additionalHeadingText = {
                pc: '',
                mb: ''
                };
                
                // 查找当前按钮的button-wrapper父节点
                let buttonWrapper = button.closest('.button-wrapper');
                
                if (buttonWrapper) {
                // 查找button-wrapper的前一个兄弟元素blocks-heading-content
                let prevSibling = buttonWrapper.previousElementSibling;
                
                while (prevSibling) {
                    if (prevSibling.classList && prevSibling.classList.contains('blocks-heading-content')) {
                    // 查找主标题文本元素
                        const mainHeadingElement = prevSibling.querySelector('.blocks-content-heading');
                        if (mainHeadingElement) {
                        // 获取 PC 端主标题文本
                        const pcMainElement = mainHeadingElement.querySelector('.hidden.lg\\:block');
                        if (pcMainElement) {
                            additionalHeadingText.pc = pcMainElement.textContent.trim();
                        }
                        
                        // 获取 MB 端主标题文本
                        const mbMainElement = mainHeadingElement.querySelector('.block.lg\\:hidden');
                        if (mbMainElement) {
                            additionalHeadingText.mb = mbMainElement.textContent.trim();
                        }
                        }
                    break; // 找到第一个匹配的就停止
                    }
                    prevSibling = prevSibling.previousElementSibling;
                }
                }
                
                // 根据屏幕尺寸选择对应的附加文案
                const selectedAdditionalText = isDesktop ? additionalHeadingText.pc : additionalHeadingText.mb;
                
                // 构建埋点参数
                const gaParams = {
                module: selectedHeadingText,
                position: selectedAdditionalText,
                button_text: buttonText,
                link: href
                };
                
                // 调用埋点函数
                gaPushDataLayer('vimage_text_one_line_user_click', gaParams);
            });
        });
    });
});
